import DefaultTheme from '@web-ui-kit/themes.default-theme'
import { LAYOUT_GRID } from 'utils/constants/layout'

export const isMobile = (windowWidth) => windowWidth <= parseInt(LAYOUT_GRID.MOBILE.max, 10)

export const isDesktop = (windowWidth) => windowWidth >= parseInt(LAYOUT_GRID.DESKTOP.min, 10)

export const isTablet = (windowWidth) =>
  windowWidth >= parseInt(LAYOUT_GRID.TABLET_PORTRAIT.min, 10) &&
  windowWidth <= parseInt(LAYOUT_GRID.TABLET_LANDSCAPE.max, 10)

export const isTablePortrait = (windowWidth) =>
  windowWidth >= parseInt(LAYOUT_GRID.TABLET_PORTRAIT.min, 10) &&
  windowWidth <= parseInt(LAYOUT_GRID.TABLET_PORTRAIT.max, 10)

export const isMobileOrPortraitTablet = (windowWidth) =>
  windowWidth <= parseInt(LAYOUT_GRID.TABLET_PORTRAIT.max, 10)

export const getDeviceType = (windowWidth) => {
  if (isMobile(windowWidth)) return 'mobile'
  if (isTablet(windowWidth)) return 'tablet'
  if (isDesktop(windowWidth)) return 'desktop'
}

export const getColor = (theme, name) => theme?.colors?.[name] ?? DefaultTheme.colors[name]
export const getFontFamily = (theme, name) => theme?.fonts?.[name] ?? DefaultTheme.fonts[name]
export const getSpace = (theme, name) => theme?.spaces?.[name] ?? DefaultTheme.spaces[name]
export const getShadow = (theme, name) => theme?.shadows?.[name] ?? DefaultTheme.shadows[name]
